import FlushAccordian from "src/SharedComponents/FlushAccordian/FlushAccordian";
import { useGetTutorialVideosWrapper } from "src/Utils/Hooks/Downloads/useGetTutorialVideosWrapper";
import Document from "./../Documents/Document";
import { useTranslation } from "react-i18next";

const TutorialVideos = () => {
    const { t } = useTranslation();
    const { data } = useGetTutorialVideosWrapper()
    return (
        <>
            {data &&
                <>
                    <hr className='ds-text-primary ds-divider mt-4'></hr>
                    <FlushAccordian title={t('TutorialVideos')} id='techVideos'>
                        <>
                            <div className="row" style={{ margin: 'auto' }}>
                                {data.map((video, i) => (
                                    <div className="col-md-4 col-sm-12" style={{ padding: '0' }} key={i}>
                                        <div className="m-1">
                                            <Document key={i} image={video.previewData} title={video.displayName} fileLink={video.sasToken} duration={video.duration} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    </FlushAccordian>
                </>

            }
        </>
    )
}
export default TutorialVideos;